import { useBackend } from "../../services";

export const useGetAlbumTypeProducts = () => {
  const { get } = useBackend();
  const getAlbumTypeProducts = () => get("products/albumTypes");
  return { getAlbumTypeProducts };
};
